import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { KYMW5002UseImageComponent } from './kymw5002-use-image.component';
import { ImageInfoRendererModule } from '../image-info-renderer/image-info-renderer.module';

/**
 * EC使用画像指示画面 モジュール設定クラス
 *
 * @export KYMW5002UseImageModule
 * @class KYMW5002UseImageModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjInputModule,
    ImageInfoRendererModule
  ],
  declarations: [
    KYMW5002UseImageComponent,
  ],
  providers: [
  ],
  exports: [
    KYMW5002UseImageComponent,
  ]
})
export class KYMW5002UseImageModule {

}
